export const APP_EVENT = {
  INACTIVITY_TIMEOUT: 'inactivityTimeout',
  TENANT_CHANGED: 'tenantChanged',
} as const;
